import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccountUserService } from 'src/app/services/account-user.service';

@Component({
  selector: 'app-change-label-status.component',
  templateUrl: './change-label-status.component.html',
  styleUrls: ['./change-label-status.component.css']
})
export class ChangeLabelStatusComponent implements OnInit {

  api_error: any;
  api_success: string;
  label_status: string;
  statusTo: string;
  disableConfirmbtn = false;
  label_id: any;
  constructor(private dialogRef: MatDialogRef<any>,
     @Inject(MAT_DIALOG_DATA) public data: any,
     private accountuserService: AccountUserService,) { }

  ngOnInit() {
    this.label_status = this.data['labels'].status;
    this.label_id = this.data['labels'].id;
    if (this.label_status === 'ENABLED') {
      this.statusTo = 'DISABLED';
    } else {
      this.statusTo = 'ENABLED';
    }
  }
  public closeDialog() {
    this.dialogRef.close();
  }
  onConfirm() {
    this.api_error = '';
    this.api_success = '';
    this.disableConfirmbtn = true;
    this.accountuserService.changeLabelStatus(this.label_id, this.statusTo)
    .subscribe(
      data => {
        this.api_success = 'Status changed Successfully';
        setTimeout(() => {
          this.dialogRef.close('reloadlist');
          }, 2000);
        },
     (error) => {
      this.disableConfirmbtn = false;
      this.api_error = error.error;
      }
    );

  }
}
